var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetirement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.302 27.3514C29.9404 27.3514 29.7081 25.5705 25.2171 24.3703C22.0812 23.5186 18.1323 23.2863 14.2995 23.7122C13.4477 23.8283 13.1767 22.6669 13.7962 22.3184L11.9378 17.5565C11.0087 17.6339 10.8151 16.1627 11.783 16.0466C19.4099 14.8464 28.7402 15.6594 34.7411 20.2278C37.7608 22.5507 36.1348 27.3514 32.302 27.3514Z",
    fill: "#445174"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9776 53.4458C17.6679 53.4458 17.2807 53.2522 17.242 52.8264L13.9125 51.5488C13.2156 51.9746 12.4026 51.2003 12.7898 50.5035L18.8293 40.1665C19.1778 39.5471 19.9521 39.7794 20.1844 40.2827L24.2882 40.3988C24.985 39.2374 26.1852 40.244 25.7206 41.057L18.6745 53.0587C18.5196 53.3297 18.2486 53.4458 17.9776 53.4458Z",
    fill: "#AF8EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3549 54.9551C39.7742 54.9551 39.6193 54.4518 39.3096 53.9485L31.4117 40.3595C30.9471 39.5852 32.1086 38.5011 32.8442 39.7787L36.6382 39.469C36.7544 38.8496 37.6836 38.5011 38.1094 39.198L45.8137 52.516C46.2009 53.2129 45.3104 54.1808 44.5361 53.2903L41.1292 54.3356C41.0518 54.6841 40.742 54.9551 40.3549 54.9551Z",
    fill: "#AF8EFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7174 45.3542C45.2717 45.3542 44.2651 41.2117 40.5485 40.36C39.0386 40.0115 30.4438 40.902 29.205 41.0181C17.9001 42.257 13.7576 42.0634 9.3441 30.3715L0.246045 6.21325C-0.528257 4.16135 0.517051 1.87716 2.56895 1.10286C4.62085 0.328554 6.90505 1.37386 7.67935 3.42576L17.1646 28.5906C18.7906 32.888 19.41 34.4753 25.527 33.43C28.7017 32.9267 39.3483 31.9201 42.3294 32.617C45.2717 33.2751 50.4596 36.5659 52.1243 39.3147C53.7116 41.986 51.7371 45.3542 48.7174 45.3542Z",
    fill: "#C8CCD8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9927 60.6073C24.0173 60.6073 16.0033 58.5554 8.91845 54.8774C6.98269 53.8709 5.4728 52.9417 4.27263 52.09C2.87889 51.0446 2.56917 49.0315 3.61448 47.6377C4.62107 46.2053 6.63426 45.8955 8.028 46.9408C11.7447 49.6896 18.0165 52.09 22.2364 53.0965C33.5413 55.8066 44.8848 53.7547 55.1056 47.2119C56.5768 46.244 58.5512 46.6698 59.4804 48.141C60.4483 49.6122 60.0224 51.5867 58.5512 52.5545C50.1888 57.8972 41.1681 60.6073 31.9927 60.6073Z",
    fill: "#C8CCD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetirement);
export default __webpack_public_path__ + "static/media/retirement.50a40e9b480c905f71dc7fc06a5989a6.svg";
export { ForwardRef as ReactComponent };